import React, {useState, useEffect, Suspense, lazy } from 'react';
import {connect} from 'react-redux'
import {setChosenOptionCategory, calculteScores, addOptionQueryParam, setPickedTreeId, throttledLoadOptions, loadUser, setOptionDisplay, setControlOptionDisplay} from '../redux/actions'
import { Switch, Route, Link, useLocation} from "react-router-dom";
import AmazonCheckLink from './AmazonCheckLink'
import OptionsFragmentControler from './OptionsFragmentControler'
import CategoryHeader from './categoryHeader/CategoryHeader'
const Mobile = lazy(() => import('../mobile/Mobile'));
const OptionItem = lazy(() => import ('./options/OptionItem'))
const OptionsFragment = lazy(() => import ('./options/OptionsFragment'))
const PrefernceItem = lazy(() => import ('./PrefernceItem'))
const OptionsCompare = lazy(() => import ('./options/OptionsCompare'))

function useQuery(){
  return new URLSearchParams(useLocation().search);
}

function ChoseOption(props) {
  const [showPrefBar, setShowPrefBar] = useState(false);
  const [bollit, setBollit]  = useState();

  const query = useQuery();
  const treeId = query.get("treeId", null);
  const category = query.get("category", null);
  const itemId = query.get("itemId", null);
  const onChooseOptions = useLocation().pathname === "/choose";
  const LOAD_USER_PROCESS_ID = "LOAD_USER_PROCESS_ID";
  console.log(`on choose: ${onChooseOptions}`);
  useEffect(() => {
    console.log("im hooked on hooks");
    console.log(`treeId:${treeId}, category:${category}`);
    console.log(`old tree: ${props.queryParams.treeId}`);
    if(treeId && props.tree.id != treeId){
      console.log("setting new tree");
      console.log(props.tree.id);
      console.log(treeId);
      console.log(props.tree.id != treeId);
      props.addOptionQueryParam("treeId", treeId)
      props.setPickedTreeId(treeId)
    }
    if(category && props.queryParams.category != category){
      console.log("setting new category");
      props.addOptionQueryParam("category", category)
      props.setChosenOptionCategory(category)
    }
    if(itemId){
      props.addOptionQueryParam("itemId", itemId)
    }
  }, [treeId, category, itemId])

  useEffect(() => {
    try {
      this.props.loadUser(LOAD_USER_PROCESS_ID);
    } catch (e) {
      console.log(e);
    } finally {
    }
  }, [])

  useEffect(() => {
    console.log("tree context changed");
    props.loadOptions("score|title|img_url|id|amazon_url");
  }, [props.treeContext])

  const _isEmpty = (object) => {
    for(var i in object){
      return false;
    }
    return true;
   }




    {/*  // TODO:  removed build util function. pepole did not like it.
      maybe i can improve it and try again.
      if ((!this.props.treeContext) || this.isEmpty(this.props.treeContext)) {
      console.log("no tree context");
      return <Redirect to="/build_util_function" />;
      }
      */}
    return (
    <div className="py-0 text-center container-fluid chooseOption">
      <AmazonCheckLink/>
      <div className="none-sm">
        {/*<nav className="row" aria-label="breadcrumb" style={{background:""}}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Phones</li>
          </ol>
        </nav>*/}
        <CategoryHeader/>
        <div className={`row pt-4 justify-content-start pl-2 mainColor ${bollit}`}>
            <div class={`col-sm-12 col-md-4  ${showPrefBar?"":"none-sm"}`} style={{borderRight: "2px solid #ddd"}}>
              <OptionsFragmentControler/>
            </div>
            <div className={`col-sm-12 col-md-8 col-xl-7 px-5 pb-6 ${showPrefBar?"none-sm":""}`} >
              <Suspense fallback={<div>Loading...</div>}>
                  <Switch>
                    <Route exact path="/choose/optionItem">
                      <OptionItem/>
                    </Route>
                    <Route exact path="/choose/preferenceItem">
                      <PrefernceItem/>
                    </Route>
                    <Route exact path="/choose/compare">
                      <OptionsCompare/>
                    </Route>
                    <Route path="/choose">
                    <OptionsFragment/>
                    </Route>
                  </Switch>
                </Suspense>
            </div>

          </div>
      </div>
      <div className={"row only-sm"}>
        <Suspense fallback={<div>Loading...</div>}>
          <Mobile/>
        </Suspense>
      </div>

    </div>
    );
}

const mapStateToProps = (state) => ({
  treeContext: state.nodesData,
  tree: state.preferenceTree,
  optionMetaData: state.options.optionMetaData,
  options: state.options.optionsChosen,
  queryParams: state.optionQueryParams,
  prefItem:state.preferenceItem,
  controlFormat: state.displayState.controlOptionsDisplay,
  viewFormat: state.displayState.optionsDisplay,
  curScreen: state.curScreen,
  scores: state.options.extendedScores,
  nodes: state.preferenceTree.root_node?state.preferenceTree.root_node.children:[],
})

const actionsCreators = {
  loadUser: loadUser,
  setPickedTreeId:setPickedTreeId,
  setChosenOptionCategory: setChosenOptionCategory,
  calculteScores: calculteScores,
  addOptionQueryParam:addOptionQueryParam,
  loadOptions:throttledLoadOptions,
  setOptionDisplay:setOptionDisplay,
  setControlOptionDisplay:setControlOptionDisplay,
}

export default connect(mapStateToProps, actionsCreators)(ChoseOption)
